import { render, staticRenderFns } from "./FilterEstatisticas.vue?vue&type=template&id=21d03adc"
import script from "./FilterEstatisticas.vue?vue&type=script&lang=js"
export * from "./FilterEstatisticas.vue?vue&type=script&lang=js"
import style0 from "./FilterEstatisticas.vue?vue&type=style&index=0&id=21d03adc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports